module.exports = __webpack_public_path__ + "static/media/portfolio-light.d7095cbd.d34191a9.svg";